import { NBSP } from './common';

export const FORM_SAVED_QUERY_PARAM = 'formSaved';
export const FORM_SAVED_TOAST_TEXT = `Сохранили вашу анкету. Вернуться к${NBSP}ней можно в Профиле.`;
